export default __webpack_public_path__ + "static/media/BCI_Musical_lights.e32fe681.webp";